import React, { useContext } from 'react';
import { InvoiceContext } from "../../Context/InvoiceContext"

function withInvoice(WrappedComponent) {
  return function(props) {
    const { invoice } = useContext(InvoiceContext);
    return <WrappedComponent invoice={invoice} {...props} />
  }
}

export default withInvoice;